module.exports = __webpack_public_path__ + "static/media/live-sic-bo.203f253c.svg";